import { render, staticRenderFns } from "./SalaryPolicyView.vue?vue&type=template&id=6aecc84a&"
import script from "./SalaryPolicyView.vue?vue&type=script&lang=js&"
export * from "./SalaryPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPolicyView.vue?vue&type=style&index=0&id=6aecc84a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports